/**
 * Deterministic demo imagery. Picsum went down (soft POC); Unsplash IDs are stable CDN URLs.
 * Seeds stay consistent so the same model always gets the same thumb.
 */

const CAM_LANDSCAPE = [
  'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1571266028247-e6735c2f4e2e?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=640&h=360&q=80',
  'https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=640&h=360&q=80',
] as const;

const PORTRAIT = [
  'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=900&h=1200&q=80',
  'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=900&h=1200&q=80',
  'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=900&h=1200&q=80',
  'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=900&h=1200&q=80',
  'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=900&h=1200&q=80',
  'https://images.unsplash.com/photo-1571266028247-e6735c2f4e2e?auto=format&fit=crop&w=900&h=1200&q=80',
] as const;

const AVATAR = [
  'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1571266028247-e6735c2f4e2e?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=160&h=160&q=80',
  'https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=160&h=160&q=80',
] as const;

/** Hero / full-bleed CSS backgrounds (landscape). */
export const PLACEHOLDER_HERO_URL =
  'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=2400&h=1600&q=80';

export const PLACEHOLDER_EDITORIAL_URL =
  'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1920&h=1200&q=80';

export const PLACEHOLDER_AUTH_URL =
  'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=900&h=1200&q=80';

function hashSeed(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return hash;
}

function pick<T extends readonly string[]>(pool: T, seed: string): T[number] {
  return pool[hashSeed(seed) % pool.length]!;
}

export function camThumbUrl(username: string): string {
  return pick(CAM_LANDSCAPE, `cam:${username}`);
}

export function featuredThumbUrl(username: string, index: number): string {
  return pick(PORTRAIT, `feature:${username}:${String(index)}`);
}

export function avatarUrl(username: string): string {
  return pick(AVATAR, `avatar:${username}`);
}

export function onboardingImageUrl(seed: string, width = 720, height = 900): string {
  const base = pick(PORTRAIT, `onboard:${seed}`);
  return base.replace(/w=\d+/, `w=${String(width)}`).replace(/h=\d+/, `h=${String(height)}`);
}
